import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { UserCog, Loader2 } from "lucide-react";
import { conRuolo } from "@/lib/ruoli";

export default function CambiaAgente({ im, onDone }) {
  const [list, setList] = useState(null);
  const [sel, setSel] = useState("");
  const [busy, setBusy] = useState(false);
  const apri = () => api.get(`/immobili/${im.id}/agenti-disponibili`).then((r) => { setList(r.data); setSel(""); }).catch((e) => toast.error(apiError(e)));
  const conferma = async () => {
    const nome = list.find((u) => u.id === sel)?.name;
    if (!window.confirm(`Assegnare l'immobile a ${nome}? Passeranno a ${nome} anche i task aperti e il venditore collegato.`)) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/immobili/${im.id}/cambia-agente`, { owner_agent_id: sel });
      toast.success(`Agente cambiato: ${data.agente} (${data.task_spostati} task spostati${data.venditore_spostato ? ", venditore spostato" : ""})`);
      setList(null); onDone();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <div className="card-immo p-4 mb-4 flex items-center gap-3 flex-wrap" data-testid="cambia-agente-box">
      <UserCog size={18} className="text-[#FC82ED]" />
      <span className="text-sm">Agente: <b data-testid="immobile-agente-nome">{im.owner_agent_name || "—"}</b></span>
      {im.agente_da_assegnare && <span className="text-[10px] font-bold uppercase px-2 py-0.5 rounded-full bg-amber-100 text-amber-800">Agente da assegnare</span>}
      {!list ? (
        <button data-testid="cambia-agente-btn" onClick={apri} className="ml-auto px-3 py-2 rounded-xl border border-[#111111] text-xs font-semibold hover:bg-slate-50">Cambia agente</button>
      ) : (
        <div className="ml-auto flex items-center gap-2 flex-wrap">
          <select data-testid="cambia-agente-select" value={sel} onChange={(e) => setSel(e.target.value)} className="px-3 py-2 rounded-xl border border-[var(--border)] text-base sm:text-sm bg-white">
            <option value="">— Scegli l'agente —</option>
            {list.filter((u) => u.id !== im.owner_agent_id).map((u) => <option key={u.id} value={u.id}>{conRuolo(u)}</option>)}
          </select>
          <button data-testid="cambia-agente-conferma" onClick={conferma} disabled={!sel || busy} className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl bg-[#111111] text-white text-xs font-semibold disabled:opacity-40">{busy && <Loader2 size={13} className="animate-spin" />} Conferma</button>
          <button data-testid="cambia-agente-annulla" onClick={() => setList(null)} className="px-3 py-2 rounded-xl border border-[var(--border)] text-xs">Annulla</button>
        </div>
      )}
    </div>
  );
}
